import { User } from '@chiroup/core/types/User.type';
import { useDebounce } from '@chiroup/hooks/useDebounce';
import { useState } from 'react';
import { QueryFunctionContext, useInfiniteQuery } from 'react-query';
import userService from '../services/user.service';

const getQuery = () => {
  return async (context: QueryFunctionContext) => {
    const searchTerm = context.queryKey[1] as string;
    const search = searchTerm || '';

    return userService.list({ skip: context.pageParam, search });
  };
};

const useUsers = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const debouncedSearch = useDebounce(searchQuery);
  const {
    status,
    data,
    error,
    isFetching,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    refetch,
  } = useInfiniteQuery<{ data: User[]; skip: number }>(['users', debouncedSearch], getQuery(), {
    getNextPageParam: lastGroup => lastGroup?.skip || undefined,
    refetchOnWindowFocus: false,
  });

  const onSearch = (params: string) => {
    setSearchQuery(params);
  };

  return {
    status,
    data,
    error,
    isFetching,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    refetch,
    onSearch,
  };
};

export default useUsers;
